import type {
  InviteGrantRequest,
  InviteGrantResponse,
  InviteRedeemRequest,
  InviteRedeemResponse,
  MyInvitesResponse,
  User,
} from '@eloquor/api-contract';
import { apiFetch } from './client';

export async function redeemInvite(req: InviteRedeemRequest): Promise<InviteRedeemResponse> {
  return apiFetch<InviteRedeemResponse>('/invites/redeem', { method: 'POST', json: req });
}

export interface SignUpRequest {
  code: string;
  email: string;
  displayName: string;
  handle: string;
}

export interface SignUpResponse {
  ok: true;
  user: User;
}

export async function signUp(req: SignUpRequest): Promise<SignUpResponse> {
  return apiFetch<SignUpResponse>('/invites/signup', { method: 'POST', json: req });
}

export async function listMyInvites(): Promise<MyInvitesResponse> {
  return apiFetch<MyInvitesResponse>('/invites/mine');
}

export async function grantInvite(req: InviteGrantRequest): Promise<InviteGrantResponse> {
  return apiFetch<InviteGrantResponse>('/invites/grant', { method: 'POST', json: req });
}
